'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../../../util');

var _util2 = _interopRequireDefault(_util);

var _icon = require('../../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _button = require('../../../button');

var _button2 = _interopRequireDefault(_button);

var _bill = require('../../../bill');

var _bill2 = _interopRequireDefault(_bill);

var _lodashCompat = require('lodash-compat');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * 高级搜索条件
 */

var AdvancedSearch = function (_M$BaseComponent) {
  _inherits(AdvancedSearch, _M$BaseComponent);

  function AdvancedSearch(props) {
    _classCallCheck(this, AdvancedSearch);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AdvancedSearch).call(this, props));

    _this.searchData = _extends({}, _this.props.searchData) || {};
    return _this;
  }

  _createClass(AdvancedSearch, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var model = _props.model;
      var billData = _props.billData;

      return _react2.default.createElement(
        'div',
        { className: this.classNames("advanced-search") },
        _react2.default.createElement(
          'div',
          { className: 'advanced-search__header' },
          _react2.default.createElement(
            'div',
            null,
            '高级搜索'
          ),
          _react2.default.createElement(_icon2.default, { className: 'advanced-search__close-icon',
            type: 'close', domProps: { onClick: this._close } })
        ),
        _react2.default.createElement(
          'div',
          { className: 'advanced-search__content' },
          _react2.default.createElement(_bill2.default, { ref: 'bill',
            model: model,
            data: billData,
            onFieldChange: this._onFieldChange })
        ),
        _react2.default.createElement(
          'div',
          { className: 'advanced-search__footer' },
          _react2.default.createElement(_button2.default, { className: 'advanced-search__operation-btn', label: '重置', onClick: this._reset }),
          _react2.default.createElement(_button2.default, { className: 'advanced-search__operation-btn', type: 'primary', label: '搜索', onClick: this._confirm })
        )
      );
    }
  }, {
    key: '_close',
    value: function _close() {
      var onClose = this.props.onClose;

      onClose && onClose();
    }
  }, {
    key: '_reset',
    value: function _reset() {
      this.refs.bill.reset();
    }
  }, {
    key: '_confirm',
    value: function _confirm() {
      var onConfirm = this.props.onConfirm;

      onConfirm && onConfirm(this.searchData);
    }
  }, {
    key: '_onFieldChange',
    value: function _onFieldChange(code, value, bill) {
      // bill.getData()是打平的数据，默认存储的数据
      var model = bill.getFieldModel(code);

      (function () {
        switch (model.type) {
          case 'select':
          case 'treeSelect':
            // 如果value是对象且value.value是假值
            if ((0, _lodashCompat.isObject)(value) && !value.value) {
              value = undefined;
            }
            break;
          case 'rangeDate':
            // 如果开始和结束都不存在且不是至今
            if (!value[0] && !value[1] && !value[2]) {
              value = [];
            }
            break;
          case 'radio':
          case 'checkbox':
            // 封装value
            var range = model.range || model.conf.range || model.conf.model || [];
            if ((0, _lodashCompat.isArray)(value)) {
              value = value.map(function (item) {
                return (0, _lodashCompat.find)(range, { value: item });
              });
            } else {
              value = (0, _lodashCompat.find)(range, { value: value });
            }
            break;
        }
      })();

      this.searchData[code] = value;
    }
  }]);

  return AdvancedSearch;
}(_util2.default.BaseComponent);

exports.default = AdvancedSearch;